import { ApiModel } from "./api-model";
import { ProgramArticlePictureETTValue } from "./program-article-translation-value";

export class PictureSets extends ApiModel {
  validatedEmissionId: number;
  channelId: number;
  languageId: number;
  destinationId: number;
  hasReplays: boolean;
  pictureSets: PictureSet[];

  constructor(data: any) {
    super(data);
  }
}

export class PictureSet extends ApiModel {
  setId: number;
  format: string;
  pictures: ProgramArticlePictureETTValue[];

  constructor(data: any) {
    super(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/pictureSets.ts